const BR = {
  associationIncorporated: [
    "associação",
    "cooperativas"
  ],
  partnershipIncorporated: [
    "sociedade em nome coletivo",
    "sociedade em comandita simples",
    "sociedade em comandita por ações"
  ],
  partnershipUnincorporated: [
    "sociedade em comum (no legal personality)",
    "sociedade em conta de participação"
  ]
};
export {
  BR as default
};
